import Form from "./Form";
import Label from "./Label";
// DEPRECATED: Select (native) - Use Dropdown (custom button) instead for consistent UX
import Dropdown from "./Dropdown";
import MultiSelect from "./MultiSelect";
import { TextField, TextAreaField } from "./fields";
import Checkbox from "./controls/Checkbox";
import DateOfBirthField from "./DateOfBirthField";
import DateField from "./DateField";
// DEPRECATED: DateTimePicker - Use DatePicker (Flatpickr) instead
// import DateTimePicker from "./DateTimePicker";
import AddressFieldSet from "./AddressFieldSet";
import DropdownField from "./DropdownField";

export {
  Form,
  Label,
  // Re-export Dropdown as Select for backward compatibility
  Dropdown as Select,
  MultiSelect,
  TextField,
  TextField as Input, // Export TextField as Input for backward compatibility
  TextAreaField,
  TextAreaField as TextArea, // Export TextAreaField as TextArea for backward compatibility
  Checkbox,
  DateOfBirthField,
  DateField,
  // DEPRECATED: DateTimePicker - Use DatePicker (Flatpickr) instead
  // DateTimePicker,
  AddressFieldSet,
  Dropdown,
  DropdownField,
}; 